"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import teleconference from "../../assets/teleconference.jpg";

export default function BusinessSectionMice() {
  return (
    <BusinessSectionBlock
      title="Start exploring MICE"
      description="Rent spaces and buildings for various events and purposes such as meetings, workshops, alumni gatherings, weddings, conferences, exhibitions, and others."
      image={teleconference}
      href="/mice"
      reverse={false}
    />
  );
}